import { Add } from '@mui/icons-material';
import { Button, Grid, Typography } from '@mui/material';
import { useEffect } from 'react';
import { ContainerTable, ToolbarModule } from '../../../../../components';
import { useLoading, useNotify } from '../../../../../hooks';
import { WorkPlaceService } from '../../../../../services';
import { ClaveCentroTrabajo } from '../../../../../utils/models/clave-centro-tabajo';
import { useWorkPlace } from '../../hook/useWorkPlace';
import { WorkPlaceRecord } from '../../modals/WorkPlaceRecord';
import { SearchWorkPlace } from '../WorkPlaceSearch/SearchWorkPlace';
import { WorkPlaceTable } from '../WorkPlaceTable/WorkPlaceTable';

export const WorkPlacePage = () => {
  const workPlaceService = new WorkPlaceService();

  const { notify, setNotify } = useNotify();
  const { setLoading } = useLoading();
  const {
    setWorkCenterKeyList,
    setPaginatorOptions,
    search,
    rowsPerPage,
    page,
    setPage,
    setModal,
    modalRecord,
    orderBy,
    dir,
  } = useWorkPlace();

  const getAllWorkCenterKeys = async (
    filtro?: string,
    pageSize?: number,
    pageNumber?: number,
    ordenar?: string,
    dir?: string,
  ) => {
    setLoading(true);
    await workPlaceService
      .getAllWorkCenterKeys(pageSize, pageNumber, ordenar, dir, filtro, true)
      .then((response) => {
        setLoading(false);
        const res = response.data;
        if (res.success) {
          if (res.data.data.length === 0) {
            setNotify({
              ...notify,
              open: true,
              message: 'No se encontró un centro de trabajo',
              type: 'info',
            });
          }
          const data: ClaveCentroTrabajo[] = res.data.data.map((work) =>
            new ClaveCentroTrabajo().deserialize(work),
          );
          setWorkCenterKeyList(data);
          setPaginatorOptions(res.data);
        } else {
          setNotify({
            ...notify,
            open: true,
            message: res.message,
            type: 'error',
          });
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onSearch = (value: string) => {
    const valuePage = 1;
    setPage(valuePage);
    getAllWorkCenterKeys(value, rowsPerPage, valuePage, orderBy, dir);
  };

  const onReloadData = () => {
    getAllWorkCenterKeys(search, rowsPerPage, page, orderBy, dir);
  };

  const onTableFilter = async (
    pageSize: number,
    pageNumber: number,
    orderBy: string,
    asc: string,
  ) => {
    getAllWorkCenterKeys(search, pageSize, pageNumber, orderBy, asc);
  };

  useEffect(() => {
    onReloadData();
  }, []);

  return (
    <>
      <WorkPlaceRecord onReloadData={onReloadData}></WorkPlaceRecord>
      <Grid container>
        <ToolbarModule
          title="Administrar centros de trabajo"
          descriptionTmp={
            <>
              <Typography variant="subtitle2" color="grayCustom.main">
                Gestiona las claves de los Centros de Trabajo autorizados.
              </Typography>
            </>
          }></ToolbarModule>
        <ContainerTable
          title="Centros de Trabajo"
          actions={
            <Grid container px={0}>
              <SearchWorkPlace onSearch={onSearch}></SearchWorkPlace>
              <Grid
                item
                container
                direction="row"
                xs={12}
                md={6}
                justifyContent="flex-end">
                <Button
                  variant="contained"
                  sx={{
                    ml: { xs: 0, md: 2 },
                    my: 1,
                    width: { xs: '100%', md: 'auto' },
                    justifyContent: { xs: 'flex-start', md: 'center' },
                  }}
                  startIcon={<Add />}
                  onClick={() =>
                    setModal({
                      ...modalRecord,
                      show: true,
                      type: 'add',
                      campusId: null,
                      programa: null,
                    })
                  }>
                  Crear CCT
                </Button>
              </Grid>
            </Grid>
          }
          table={
            <Grid item md={12} sx={{ mt: 4 }}>
              <WorkPlaceTable
                onReloadData={onReloadData}
                onTableFilter={onTableFilter}></WorkPlaceTable>
            </Grid>
          }
        />
      </Grid>
    </>
  );
};
